import VSelectIsNumberLimit from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectIsNumberLimit', VSelectIsNumberLimit),
};
